
  import { defineComponent, PropType } from 'vue';
  import { mapGetters } from 'vuex';

  import { VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TForeignTradeByRegionsFilter } from '../../types/foreign-trade-by-regions';
  import { getBaseTreeInfo } from '../../utils/base-info/tree';
  import BaseInfo from '../common/base-info/BaseInfo.vue';
  import { TBaseInfoItem } from '../common/base-info/types';

  export default defineComponent({
    name: 'ForeignTradeByRegionsBaseInfo',
    components: {
      BaseInfo,
    },
    props: {
      productText: {
        type: String,
      },
      filter: {
        type: Object as PropType<TForeignTradeByRegionsFilter>,
        required: true,
      },
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
      }),
      getItems(): TBaseInfoItem[] {
        return [this.getCountriesItem, this.getProductsItem, this.getSourceItem];
      },
      getCountriesItem(): TBaseInfoItem {
        return {
          label: 'Страна-партнер',
          value: getBaseTreeInfo(this.getCountriesTree, this.filter.countries),
          isLoading: !this.getCountriesTree.length,
        };
      },
      getProductsItem(): TBaseInfoItem {
        return {
          label: 'Товар',
          value: this.productText ?? '',
          isLoading: this.productText == null,
        };
      },
      getSourceItem(): TBaseInfoItem {
        return {
          label: 'Источник',
          value: 'Федеральная таможенная служба',
          isLoading: false,
        };
      },
    },
  });
